
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { AuthController } from "@/app/ui/controllers/AuthController";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import UserProfileSection from "@/app/ui/views/account/user-profile-section.vue";
import DataAccountSection from "@/app/ui/views/account/data-account-section.vue";
import Logout from "@/app/ui/components/icons/modules/logout.vue";
import ModalChangePassword from "@/app/ui/views/account/modal-change-password.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import ModalChangeEmail from "@/app/ui/views/account/modal-change-email.vue";
import QRCodeProfile from "@/app/ui/components/qr-code-hub/index.vue";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Utils";
import { TokenVerificationAccountEntities } from "@/domain/entities/Auth";
import { DeviceAuth } from '@/domain/entities/Account';
import DeviceAuthSection from "@/app/ui/views/account/device-auth-section.vue";
import { FlagsOtp } from "@/feature-flags/flags-otp";
import { recaptchaV3 } from "@/app/infrastructures/misc/common-library/RecaptchaV3";
import { OtpRequest } from "@/data/payload/api/AuthRequest";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ModalMessageEntities } from "@/domain/entities/MainApp";

@Options({
  components: {
    ModalChangeEmail,
    DataAccountSection,
    UserProfileSection,
    DetailLayout,
    Logout,
    ModalChangePassword,
    QRCodeProfile,
    DeviceAuthSection
  },
  computed: {
    getCurrentRoute() {
      return this.$route.name;
    }
  }
})
export default class Account extends Vue {
  listDeviceAuth: DeviceAuth[] = []

  get type() {
    return String(this.$route.query.type);
  }

  mounted() {
    this.getListDeviceAuth();
    if (this.type === "change-password") {
      this.openModalChangePassword()
    } 
  }

  get isSenderDashboard() {
    return IS_SENDER_ACCOUNT;
  }

  // data profile account
  fetchDataProfile() {
    return AccountController._getData();
  }
  get dataProfile() {
    return AccountController.accountData;
  }
  get isLoading() {
    return AuthController.isLoading;
  }
  get isErrorInternetOrSystem() {
    return AccountController.isError;
  }
  get isLoadingAccount() {
    return AccountController.isLoading;
  }
  get errorCause() {
    return AccountController.errorCause;
  }
  get emailUser() {
    return this.otpData.emailUser;
  }
  get phoneUser() {
    return this.otpData.phoneUser;
  }
  get showMfaEnrollmentAlert() {
    return (
      AccountController.accountData.isLogin2FaEnable &&
      !AccountController.accountData.isLogin2FaEnrolled
    );
  }

  // logout
  isOpenModal = false;
  onOpenLogout() {
    this.isOpenModal = true;
  }
  onCloseLogout() {
    this.isOpenModal = false;
  }
  async onSubmitLogout() {
    this.isOpenModal = false;
    await AuthController.logout();
  }
  handleCloseError() {
    return AuthController.handleErrorLogout();
  }
  get errorCauseLogout() {
    return AuthController.errorCause;
  }
  get isErrorInternetOrSystemLogout() {
    return AuthController.isErrorLogout;
  }

  // modal change password
  modalChangePassword = false;
  isSenderChangePassword = false;
  openModalChangePassword() {
    if (this.isSenderDashboard) {
      this.isSenderChangePassword = true;
    } else {
      MainAppController.setSnackbar(false);
      this.modalChangePassword = true;
    }
  }
  goToMfaVerifyOtp() {
    AuthController.autoRequestOtpAndRedirect();
  }
  get dialogData() {
    if (this.isSenderChangePassword) {
      return {
        title: this.$t("Ubah Password Melalui Aplikasi"),
        message: this.$t(
          "Silahkan ubah password Anda melalui aplikasi Lion Parcel"
        ),
        image: "account-pin-lock",
        textSuccess: this.$t("Tutup"),
        onSuccess: () => (this.isSenderChangePassword = false)
      };
    }
    return {
      title: this.$t("profile.logoutConfirmTitle"),
      message: this.$t(
        "Sebelum keluar, pastikan kembali tidak ada aktivitas yang sedang berjalan."
      ),
      image: this.$t("logout-image"),
      textClose: this.$t("Ya"),
      onClose: this.onSubmitLogout,
      textSuccess: this.$t("Tidak"),
      onSuccess: this.onCloseLogout
    };
  }

  // modal change email
  modalChangeEmail = false;
  modalChangeEmailPassword = false;
  showChangeEmailOtpModal = false;
  changeEmailMaskedEmail = "";
  changeEmailOtpError = "";
  changeEmailPassword = "";
  changeEmailNewEmail = ""
  changeEmailToken = "";
  newEmailChange = "";

  get isChangeEmailWizardEnabled(): boolean {
    return FlagsOtp.permission_change_email_otp_enable.isEnabled();
  }

  openModalChangeEmail() {
    MainAppController.setSnackbar(false);
    this.modalChangeEmail = true;
  }

  onCloseChangeEmailWizard() {
    this.modalChangeEmail = false;
    this.modalChangeEmailPassword = false;
  }

  onSubmitNewEmail(_payload: { new_email: string }) {
    // Phase 1 stub — stored internally in modal; API call in GENESIS-15110
  }

  async onSubmitLegacyEmail({ new_email }: { new_email: string }) {
    const resp = await AccountController.editEmailAccount({ email: new_email });
    if (resp) {
      this.fetchDataProfile();
      MainAppController.setSnackbarMessage(this.$t("Perubahan email berhasil !"));
      MainAppController.setSnackbar(true);
    }
    this.modalChangeEmail = false;
  }

  async onPasswordConfirmedEmail({ new_email, password }: { new_email: string; password: string }) {
    MainAppController.showLoading();
    this.newEmailChange = new_email;

    try {
      const captchaToken = await recaptchaV3.executeRecaptcha("change_email");

      const otpData = await AuthController.requestOtp(
        new OtpRequest({
          password: password,
          captchaToken,
          action: 'change_email',
          newEmail: new_email
        })
      );

      if(otpData.token) {
        const atIdx = new_email.indexOf("@");
        const local = new_email.slice(0, atIdx);
        const domain = new_email.slice(atIdx);
        this.changeEmailPassword = password
        this.changeEmailMaskedEmail =
          local.length > 2
            ? local.charAt(0) + "***" + local.charAt(local.length - 1) + domain
            : local.charAt(0) + "***" + domain;
        this.showChangeEmailOtpModal = true;
        this.changeEmailNewEmail = new_email;
        this.changeEmailToken = otpData.token;
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse( error, this.$t("Perubahan email gagal"), () => {
          MainAppController.closeErrorMessage();
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onVerifyChangeEmailOtp(otp: string, changeEmailToken: string) {
    MainAppController.showLoading();

    try {
      const resp = await AccountController.editEmailAccount({ email: this.changeEmailNewEmail, token: changeEmailToken || this.changeEmailToken, otp: otp });

      if (resp) {
        this.fetchDataProfile();
        this.onCloseChangeEmailWizard()
        this.onCloseChangeEmailOtp(false)
        
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: this.$t("Email Berhasil Diperbarui"),
            message: this.$t("Email baru Anda sudah berhasil disimpan."),
            textSuccess: this.$t("Oke"),
            onSubmit: () => {
              MainAppController.closeMessageModal();
            }
          })
        )
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, this.$t("Perubahan email gagal"), () => {
          MainAppController.closeErrorMessage();
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  onCloseChangeEmailOtp(value: boolean) {
    if (!value) {
      this.showChangeEmailOtpModal = false;
      this.changeEmailMaskedEmail = "";
      this.changeEmailOtpError = "";
    }
  }

  //  download qr code
  get partnerDetail() {
    const partner = this.dataProfile.account_type_detail;
    return {
      id: partner.id,
      name: partner.company_name,
      address: partner.address,
      roleType: this.dataProfile.account_type.toLowerCase() === "partner"
    };
  }
  downloadQRCode() {
    const qrcodeProfile: any = this.$refs.qrcodeProfile;
    qrcodeProfile.download();
  }

  openOtp = false;
  otpData = new TokenVerificationAccountEntities();
  async onEditPassword(otp: string, token: string) {
    const ref: any = this.$refs?.["modal-change-password"];
    await ref?.submitChangePassword?.(otp, token);

    this.openOtp = false;
  }
  onOpenOtp(data: TokenVerificationAccountEntities) {
    this.otpData = data;
    this.modalChangePassword = false;
    this.openOtp = true;
  }
  onUpdateOpenOtp(value: boolean) {
    if (!value) this.modalChangePassword = true;
  }

  async getListDeviceAuth() {
    try {
      MainAppController.showLoading();
      const resp = await AccountController.getListDeviceAuth();
      this.listDeviceAuth = resp;
    } catch(err) {
      console.log(err)
    } finally {
      MainAppController.closeLoading();
    }
  }

  get isEligibleSetupOtp() {
    return AccountController.accountData.isEligibleSetupOtp;
  }

  get isLogin2FaEnable() {
    return AccountController.accountData.isLogin2FaEnable
  } 
}
